export const COMPLIANCE_DEADLINE = "2027-05-14";

export const RAG = {
  RED: "#D32F2F",
  AMBER: "#F57C00",
  YELLOW: "#FBC02D",
  GREEN: "#388E3C",
  TEAL: "#00897B",
};

export const BRAND = {
  NAVY: "#003366",
  ACCENT: "#008080",
};

export function daysUntil(dateStr) {
  const target = new Date(dateStr + "T00:00:00Z").getTime();
  const now = Date.now();
  return Math.ceil((target - now) / (1000 * 60 * 60 * 24));
}

export function ragForScore(score) {
  if (score == null) return RAG.AMBER;
  if (score >= 85) return RAG.GREEN;
  if (score >= 75) return RAG.TEAL;
  if (score >= 60) return RAG.YELLOW;
  if (score >= 40) return RAG.AMBER;
  return RAG.RED;
}

// Mock assessment payload (used until App A import is wired)
export const MOCK_ASSESSMENT_ID = "mock-assessment-001";
